import { useState, useEffect, useCallback } from 'react'

import { Loader, SafeTag, Stepper, If } from '@itau-loans-www/components'
import { useProposal } from '@itau-loans-www/hooks'
import { isClient } from '@itau-loans-www/utils'
import classnames from 'classnames'

import ApplicationLayout from '../Application'
import './proposal.scss'

const Proposal = ({
  children,
  hideStepper,
  stepTitle,
  stepIndex,
  maxSteps,
  currentPage
}) => {
  const [partner, setPartner] = useState('')
  const [partnerLoader, setPartnerLoader] = useState(true)
  const { loading } = useProposal()

  const classNamesLayout = classnames('proposal', `proposal-${currentPage}`, {
    ['proposal--partner']: isClient() && partner,
    ['proposal--telhaNorte']: isClient() && partner === 'telhaNorte',
    ['proposal--magalu']: isClient() && partner === 'magalu',
    ['proposal--assai']: isClient() && partner === 'assai',
    ['proposal--pirelli']: isClient() && partner === 'pirelli',
    ['proposal--carrefour']: isClient() && partner === 'carrefour',
    ['proposal--crediffato']: isClient() && partner === 'crediffato',
    ['proposal--atacadao']: isClient() && partner === 'atacadao'
  })

  const loadPartner = useCallback(async () => {
    new Promise((resolve) => {
      if (isClient()) {
        setPartner(localStorage.getItem('partner'))
      }

      resolve()
    })
  }, [])

  useEffect(() => {
    loadPartner().finally(() => setPartnerLoader(false))
  }, [loadPartner])

  return (
    <ApplicationLayout className={classNamesLayout} currentPage={currentPage}>
      <div className="image-wrapper" />
      <div className="container">
        <SafeTag />
        <div className="proposal-row">
          <div className="-second-col" data-cy="cy-proposal-form">
            <If
              condition={!hideStepper}
              renderIf={
                <Stepper
                  className="stepper"
                  title={stepTitle}
                  index={stepIndex}
                  max={maxSteps}
                />
              }
            />
            <Loader visible={loading || partnerLoader} hasOverlay />
            {children}
          </div>
        </div>
      </div>
    </ApplicationLayout>
  )
}

export default Proposal
